import { Component, ViewEncapsulation, input, output } from '@angular/core';

/**
 * Corps d'un tuto (HTML rendu par TRP, assaini par Angular). Les liens vers un
 * autre tuto (`/aide/<slug>`) sont rendus au parent : le panneau les ouvre sur
 * place, la page navigue. Les liens vers un écran du BO (`/moni/clients`…) sont
 * rendus aussi (`ecran`), pour naviguer sans recharger. Les liens externes
 * s'ouvrent dans un nouvel onglet.
 */
@Component({
  selector: 'app-aide-contenu',
  standalone: true,
  template: `<div class="aide-contenu" [innerHTML]="html()" (click)="clic($event)"></div>`,
  styleUrl: './aide-contenu.component.scss',
  // Le HTML injecté n'hérite pas des styles encapsulés : feuille scopée par `.aide-contenu`.
  encapsulation: ViewEncapsulation.None,
})
export class AideContenuComponent {
  readonly html = input.required<string>();
  readonly lien = output<string>();
  readonly ecran = output<string>();

  clic(evenement: MouseEvent): void {
    const lien = (evenement.target as HTMLElement | null)?.closest?.('a');
    const href = lien?.getAttribute('href') ?? '';
    const interne = /^\/aide\/([a-z0-9-]+)$/.exec(href);
    if (interne) {
      evenement.preventDefault();
      this.lien.emit(interne[1]);
    } else if (/^\/(?!\/)/.test(href)) {
      evenement.preventDefault();
      this.ecran.emit(href);
    } else if (/^https?:\/\//.test(href)) {
      evenement.preventDefault();
      window.open(href, '_blank', 'noopener');
    }
  }
}
